import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import Swal from 'sweetalert2';
import Loading from 'react-simple-loading';
import logo from "../../assets/images/logo.png";



const Login = () => {
    const navigate = useNavigate();
    const [isBtn, setIsBtn] = useState(false);
    const [inputError, setInputError] = useState(false);
    const [errorResponse, setErrorResponse] = useState(false);

    
    const [passEye, setPassEye] = useState(false);
    const [inputData, setInputData] = useState({
        email: "",
        password: "",
    });

  useEffect(() => {

        if (localStorage.getItem('@user_email') && localStorage.getItem('@user_role') == 1)
            navigate("/admin/work-orders-active");
        else if (localStorage.getItem('@user_email') && localStorage.getItem('@user_role') == 2)
            navigate("/client/work-orders-active");
        else if (localStorage.getItem('@user_email') && localStorage.getItem('@user_role') == 3)
            navigate("/case-manager/work-orders-active");


    }, []);

    const handleLogin = async (e) => {
        e.preventDefault();
        setIsBtn(true);
        setErrorResponse(null);

        const { email, password } = inputData;
        if (!email || !password) {
            setInputError(true);
            setIsBtn(false)
        } else {

            setInputError(false);
            await axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/login", {
                email: email,
                password: password,
            },{
                headers: {
                  'Content-Type': 'application/json'
                },
                withCredentials: true
              })
                .then(function (response) {
                    setIsBtn(false)
                    if (response?.data?.status) {


                        if (response.data.otp === 1){
                            localStorage.setItem("@user_email",email )
                            navigate("/login-otp");

                        }
                        else{

                        localStorage.setItem("@user_role", response.data.user.role)
                        localStorage.setItem("@user_email", email)
                        localStorage.setItem("@audit_id", response.data.audit_id);

                        if (response.data.user.role === 1){

                            localStorage.setItem('@first_name', response.data.user.first_name);
                            localStorage.setItem('@last_name', response.data.user.last_name);
                            localStorage.setItem('@admin_role', response.data.user.admin_role);

                            navigate("/admin/work-orders-active");

                        }
                        else if(response.data.user.role === 2){

                            localStorage.setItem('@first_name', response.data.user.first_name);
                            localStorage.setItem('@last_name', response.data.user.last_name);
                            navigate("/client/work-orders-active");

                        }
                        else if(response.data.user.role === 3)
                        {
                            localStorage.setItem('@first_name', response.data.user.case_manager_first_name);
                            localStorage.setItem('@last_name', response.data.user.case_manager_last_name);
                            navigate("/case-manager/work-orders-active");
                        }
                    }

                    } else {

                        setErrorResponse(response?.data?.message);
                        //Swal.fire({ icon: "error", title: "Login Failed", text: response?.data?.message, footer: '<a href="/forgot-password">Forgot Password</a>' });

                    }
                })
                .catch(function (error) {
                    setIsBtn(false)

                    Swal.fire({ icon: "error", title: "Login Failed", text: error.message });

                });

        }
    };

    return (
        <div className="card card-medium" >
            <div className="card-header">
                <img src={logo} alt="MedRecAps" />
            </div>
            <div className="card-body p-4">
                <form onSubmit={(e) => handleLogin(e)}>

                    <h3 className="text-center mb-5 text-primary">Login to your account</h3>
                    {errorResponse &&
                    <div className="alert alert-danger" role="alert">
                         {errorResponse}
                    </div>
                    }
                    <div className="row mt-3">
                        <div className="col-12">
                            <label>Email: *</label>
                            <div className="input-group">
                                <input type="text" className="form-control form-control-lg" id="email"
                                 name="email"  value={inputData.email}
                                    onChange={(e) => setInputData({ ...inputData, email: e.target.value })  }
                                     />
                            </div>

                            {inputError && !inputData.email && (
                                <span className="text-danger">This field is required</span>
                            )}
                        </div>
                    </div>

                    <div className="row mt-2">
                        <div className="col-12">
                            <label>Password: *</label>

                            <div className="input-group">
                                <input type={`${!passEye ? `password` : `text`}`} className="form-control form-control-lg" id="password"
                                    name="password"  value={inputData.password}
                                    onChange={(e) =>
                                        setInputData({ ...inputData, password: e.target.value })
                                    } />
                                <span className="input-group-text eye-box">
                                    {(passEye) ? <FaEye onClick={() => setPassEye(!passEye)} /> : <FaEyeSlash onClick={() => setPassEye(!passEye)} />}
                                </span>
                            </div>


                            {inputError && !inputData.password && (
                                <span className="text-danger">This field is required</span>
                            )}

                        </div>
                    </div>

                    <div className=" text-center ">

                        <button type="submit" className="btn btn-lg btn-primary mt-3 mb-3 px-5" disabled={isBtn}>
                            {isBtn ? <Loading /> : 'Login'}
                        </button>
                        <div >
                            <Link className="btn btn-link text-primary mt-5" to="/forgot-password">Forgot Password? Click Here</Link>
                        </div>
                    </div>

                </form>
            </div>
        </div>


    );
};

export default Login;